/**
 * @module client-api-base
 * @module_directory /modules/client/base
 * @module_path attributes/drafts
 * @description This module defines which pages are excluded from the draft handling of the
 * query results. Draft values are not hidden on those pages
 * @recursive true
 * @ignore __tests__
 */
import { getCurrentGlobalContext } from "./../../context/AppCtxProvider";
import * as config from "./../../configuration/index";
const isDraftFilterAllowedAtLocation = () => {
  const ctx = getCurrentGlobalContext();
  if (
    config.System.draftValuesHandling.disabledPages.includes(ctx.page || "")
  ) {
    return false;
  }
  return true;
};
export default isDraftFilterAllowedAtLocation;
